module.exports = __webpack_public_path__ + "static/media/YM59_0.0c41b527.jpg";